import {
    Button,
    Divider,
    MessageBarBody,
    SearchBox,
    Switch,
    Tab,
    TabList,
    ToggleButton,
    Toolbar,
    ToolbarButton,
    Tooltip
} from '@fluentui/react-components';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { SettlementDetail } from '../../../models/Entities/SettlementDetails/SettlementDetail';
import SettlementDetailForm from '../SettlementDetailForm/SettlementDetailForm.Component';
import { GuideDrawer } from '../../../theme/components/GuideDrawer';
import { GuideMessageBar } from '../../../theme/components/GuideMessageBar';

// components
import SettlementDetailItem from '../SettlementDetailItem/SettlementDetailItem.Component';

// component functions
import * as ComponentFunctions from './SettlementDetailsList.Functions';

////i18Next
import { useTranslation } from 'react-i18next';

// styles
import './SettlementDetailsList.Styles.css';

type DetailsTab = 'summary' | 'itemizable' | 'rembolzable' | 'excluded';

export const SettlementDetailsListComponet = (props: ComponentFunctions.Props) => {

    // statistics
    const [totalDetails, setTotalDetails] = useState<number>(0);
    const [totalExcluded, setTotalExcluded] = useState<number>(0);
    const [totalOk, setTotalOK] = useState<number>(0);
    const [totalForReview, setTotalForReview] = useState<number>(0);

    const [showExcluded, setShowExcluded] = useState<boolean>(true);
    const [showOk, setShowOk] = useState<boolean>(true);
    const [showForReview, setShowForReview] = useState<boolean>(true);
    const [showAllwithoutMark, setShowAllwithoutMark] = useState<boolean>(true);

    // filters
    const [showZeroValueConcepts, setShowZeroValueConcepts] = useState<boolean>(false);
    const [selectedTab, setSelectedTab] = useState<DetailsTab>('summary');

    const [SelectedItemIds] = useState<number[]>([]);
    //useTranslation();
    const [t] = useTranslation();

    const handleClosePanel = () => {
        setShowDetailsForm(false);
    };

    const [filterCriteria, setFilterCriteria] = useState<string>('');
    const [showDetailsForm, setShowDetailsForm] = useState<boolean>(false);

    //load necesary data
    useEffect(() => {
        if (props.Settlement?.id) {
            props.GetAllSettlementDetails(props.SettlementId)
        }

    }, [props.SettlementId]);

    useEffect(() => {
        if (props.SettlementDetails && props.SettlementDetails.length > 0) {
            setTotalDetails(props.SettlementDetails?.length);
            setTotalExcluded(props.SettlementDetails.length);
            setTotalOK(props.SettlementDetails.length);
            setTotalForReview(props.SettlementDetails.length);
        }
    }, [props.SettlementDetails]);

    const HandleCancelForm = () => {
        setFilterCriteria('');
        props.dismissPanel();
    };

    // content

    const statistic = (label: string, className: string, value: number, checked: boolean, onClick: () => void) => (
        <Tooltip content={label} relationship="description" withArrow>
            <ToggleButton className={className} checked={checked} onClick={onClick}>
                {value.toString()}
            </ToggleButton>
        </Tooltip>
    );

    const Statistics = (
        <div className='Statistics'>
            {statistic('Pendientes de revisión', 'totalItems', totalDetails, showAllwithoutMark, () => setShowAllwithoutMark(!showAllwithoutMark))}
            {statistic('Excluidos', 'excluedItems', totalExcluded, showExcluded, () => setShowExcluded(!showExcluded))}
            {statistic('Verificados', 'okItems', totalOk, showOk, () => setShowOk(!showOk))}
            {statistic('A revisar', 'reviewItems', totalForReview, showForReview, () => setShowForReview(!showForReview))}
        </div>
    );

    const MultiSelectOptions = SelectedItemIds.length > 0 && (
        <div className='menurow'>
            <span className='ItemCounter'>Seleccinados: {SelectedItemIds.length}</span>
            <Divider vertical />
            <Toolbar aria-label="Inbox actions">
                {ComponentFunctions._items.map((item) => (
                    <ToolbarButton key={item.key} onClick={() => item.onClick?.()}>
                        {item.text}
                    </ToolbarButton>
                ))}
            </Toolbar>
        </div>
    )

    const Forms = (
        <SettlementDetailForm
            isOpen={showDetailsForm}
            dismissPanel={handleClosePanel}
            openPanel={() => undefined}
            SettlementId={props.SettlementId}
            SettlementResumeId={props.SettlementResumeId}
            SettlementDetailId={undefined}
        />
    )

    const Controls = (
        <div className='sdl-controls'>
            <Button appearance="primary" onClick={() => setShowDetailsForm(true)}>
                {t('settlementDetailList.buttons.addConcept')}
            </Button>
            <SearchBox
                placeholder={t('settlementDetailList.search.searchPatient')}
                onChange={(_event, data) => setFilterCriteria(data.value)}
                value={filterCriteria}
            />
        </div>
    );

    const Tabfilter = (
        <Switch
            label={showZeroValueConcepts ? 'Ocultar conceptos incluidos en la visita' : 'Mostrar conceptos incluidos en la visita'}
            checked={showZeroValueConcepts}
            onChange={(_event, data) => setShowZeroValueConcepts(!!data.checked)}
        />
    );

    const byPatient = (detail: SettlementDetail) => detail.patientNumberInProtocol?.toLowerCase().includes(filterCriteria.toLowerCase());
    const hasDetails = !!(props.SettlementDetails && props.SettlementDetails.length > 0);

    // Table of content
    const TableOfContent = props.isLoadingSuccessfully && (props.SettlementResumeId || filterCriteria.length > 0) && (
        <>
            {hasDetails ? props.SettlementDetails?.filter((detail: SettlementDetail) =>
                showZeroValueConcepts === false && detail.amount === 0 ? false : true ||
                byPatient(detail) && (
                    showAllwithoutMark ? true : false ||
                        showExcluded ? true : false ||
                            showOk ? true : false ||
                                showForReview ? true : false
                )
            )?.map((item: SettlementDetail) =>
            (
                <SettlementDetailItem key={item.id} SettlementId={props.SettlementId} SettlementDetailId={item.id} />
            )
            ) : null}
        </>
    );
    const TableByPatient = props.isLoadingSuccessfully && (
        <>
            {hasDetails ? props.SettlementDetails?.filter(byPatient)?.map((item: SettlementDetail) =>
            (
                <SettlementDetailItem key={item.id} SettlementId={props.SettlementId} SettlementDetailId={item.id} />
            )
            ) : null}
        </>
    );

    return (
        <GuideDrawer
            open={props.isOpen}
            size="large"
            title={t('settlementDetailList.panel.detailsLiquidatedItems')}
            eyebrow={props.Settlement?.name}
            onDismiss={props.dismissPanel}
            testId="settlement-details-list-drawer"
            secondaryAction={{ label: t('settlementDetailList.footer.cancelButton'), onClick: HandleCancelForm }}
        >
            {props.failOnLoading && props.error && (
                <GuideMessageBar intent="error" layout="multiline">
                    <MessageBarBody>
                        {props.error.ErrorMessage}
                        {props.error.Errors && props.error.Errors.length > 0 && (
                            <ul>{props.error.Errors.map((error: string, idx: number) => <li key={idx}>{error}</li>)}</ul>
                        )}
                    </MessageBarBody>
                </GuideMessageBar>
            )}
            {Controls}
            <div className='DetailsListContent'>
                {Statistics}
                <TabList selectedValue={selectedTab} onTabSelect={(_event, data) => setSelectedTab(data.value as DetailsTab)}>
                    <Tab value="summary">{t('settlementDetailList.panel.summary')}</Tab>
                    <Tab value="itemizable">{t('settlementDetailList.panel.itemizable')}</Tab>
                    <Tab value="rembolzable">{t('settlementDetailList.panel.rembolzable')}</Tab>
                    <Tab value="excluded">{t('settlementDetailList.panel.excluded')}</Tab>
                </TabList>
                <div role="tabpanel" className='sdl-tabpanel'>
                    {MultiSelectOptions}
                    {selectedTab === 'summary' && Tabfilter}
                    {props.SettlementDetails?.some && (selectedTab === 'summary' ? TableOfContent : TableByPatient)}
                </div>
            </div>
            {Forms}
        </GuideDrawer>
    );
};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(SettlementDetailsListComponet as any);
